import { lazy, Suspense } from 'react';
import { BrowserRouter, useLocation } from 'react-router-dom';
import AuthenticatedReloadPreviewPlaceholder from '../../../matter-platform/src/kernel/app-shell/AuthenticatedReloadPreviewPlaceholder.tsx';
import AuthenticationLoadingPlaceholder from '../../../matter-platform/src/kernel/auth/AuthenticationLoadingPlaceholder.tsx';
import { isAuthenticationPath } from '../../../matter-platform/src/kernel/auth/authentication-route-paths.ts';
import { isPublicPluginPath } from '../../../matter-platform/src/kernel/public-site/public-route-classifier-loader.ts';
import PublicApplicationLoadingPlaceholder from '../../../matter-platform/src/kernel/public-site/PublicApplicationLoadingPlaceholder';

const AuthenticationApplication = lazy(
  () => import('../../../matter-platform/src/kernel/auth/AuthenticationApplication.tsx'),
);
const AuthenticatedApplication = lazy(
  () => import('../../../matter-platform/src/kernel/app-shell/AuthenticatedApplication'),
);
const PublicApplication = lazy(
  () => import('../../../matter-platform/src/kernel/public-site/PublicApplication'),
);
const PublicLandingApplication = lazy(
  () => import('../../../matter-platform/src/kernel/public-site/PublicLandingApplication'),
);

function ApplicationEntryLoading({
  isAuthentication,
  isLanding,
  isLogin,
  isPublic,
}: {
  isAuthentication: boolean;
  isLanding: boolean;
  isLogin: boolean;
  isPublic: boolean;
}) {
  if (isAuthentication) {
    return <AuthenticationLoadingPlaceholder reserveLoginCardSpace={isLogin} />;
  }
  if (!isPublic) {
    return <AuthenticatedReloadPreviewPlaceholder />;
  }

  return <PublicApplicationLoadingPlaceholder landing={isLanding} />;
}

function ApplicationForCurrentRoute() {
  const { pathname } = useLocation();
  const isAuthentication = isAuthenticationPath(pathname);
  const isPublic = isPublicPluginPath(pathname);

  return (
    <Suspense
      fallback={
        <ApplicationEntryLoading
          isAuthentication={isAuthentication}
          isLanding={pathname === '/'}
          isLogin={pathname === '/login'}
          isPublic={isPublic}
        />
      }
    >
      {pathname === '/' ? (
        <PublicLandingApplication />
      ) : isAuthentication ? (
        <AuthenticationApplication />
      ) : isPublic ? (
        <PublicApplication />
      ) : (
        <AuthenticatedApplication />
      )}
    </Suspense>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <ApplicationForCurrentRoute />
    </BrowserRouter>
  );
}
